<script lang="ts" setup>
const columnControlPreference = useCookie('mhj-column-control', {
  default: () => 'standard',
})

const handleClick = (preference: string) => {
  columnControlPreference.value = preference
}
</script>

<template>
  <div class="plp-column-control">
    <button
      class="plp-column-control__button plp-column-control__button--less"
      :class="{ selected: columnControlPreference === 'less' }"
      :aria-pressed="columnControlPreference === 'less'"
      data-testid="plp-column-control-less"
      @click="handleClick('less')"
    >
      <svg-icon name="mhj:column-control-less" />
    </button>
    <button
      class="plp-column-control__button plp-column-control__button--standard"
      :class="{ selected: columnControlPreference === 'standard' }"
      :aria-pressed="columnControlPreference === 'standard'"
      data-testid="plp-column-control-standard"
      @click="handleClick('standard')"
    >
      <svg-icon name="mhj:column-control-standard" />
    </button>
    <button
      class="plp-column-control__button plp-column-control__button--more"
      :class="{ selected: columnControlPreference === 'more' }"
      :aria-pressed="columnControlPreference === 'more'"
      data-testid="plp-column-control-more"
      @click="handleClick('more')"
    >
      <svg-icon name="mhj:column-control-more" />
    </button>
  </div>
</template>

<style lang="postcss">
.plp-column-control {
  display: flex;
  justify-content: space-between;
  gap: var(--space-20);
  .plp-column-control__button {
    color: var(--ui-neutral-30);
    > .icons {
      width: var(--space-50);
      height: var(--space-50);
    }
    &:after {
      content: '';
      display: block;
      width: 50%;
      height: 1px;
      margin-top: 1px;
      margin-left: auto;
      margin-right: auto;
    }
    &.selected {
      color: var(--ui-dark-10);
      &:after {
        background-color: var(--ui-dark-10);
      }
    }
    &.plp-column-control__button--more {
      @media (--mobile-only) {
        display: none;
      }
    }
  }
}
</style>
